const MESSAGE = {
    city_required: "Укажите город.",
    city_not_from_dict: "Выберите город из списка.",

    street_type_required: "Укажите тип улицы.",
    street_type_not_from_dict: "Выберите тип улицы из списка.",

    street_required: "Укажите улицу.",
    street_too_short: "Название улицы слишком короткое.",
    street_too_long: "Название улицы слишком длинное.",

    house_required: "Укажите номер дома.",
    house_too_long: "Номер дома слишком длинный.",

    office_too_long: "Номер офиса слишком длинный.",

    carrier_required: "Укажите грузоперевозчика.",
    carrier_not_from_dict: "Выберите грузоперевозчика из списка.",

    first_required: "Укажите имя.",
    first_too_short: "Имя слишком короткое.",
    first_too_long: "Имя слишком длинное.",

    last_required: "Укажите фамилию.",
    last_too_short: "Фамилия слишком короткая.",
    last_too_long: "Фамилия слишком длинная.",

    middle_too_short: "Отчество слишком короткое.",
    middle_too_long: "Отчество слишком длинное.",

    phone_required: "Укажите телефон.",
    phone_format: "Телефон должен быть в формате +7XXXXXXXXXX.",
    phone_digits: "Неверное количество цифр в номере телефона.",

    schedule_type_required: "Укажите тип расписания.",
    schedule_type_invalid: "Некорректный тип расписания.",

    single_required: "Укажите время работы.",
    single_format: "Некорректный формат времени. Используйте HH:MM–HH:MM.",
    time_order: "Время начала должно быть меньше времени окончания.",

    week_format: "Некорректный формат времени для выбранного дня.",

    comment_too_long: "Комментарий слишком длинный (до 500 символов).",

    min_required: "Укажите минимальный срок хранения.",
    min_not_number: "Минимальный срок хранения должен быть числом.",
    min_negative: "Минимальный срок хранения не может быть отрицательным.",
    min_gt_365: "Минимальный срок хранения не может превышать 365 дней.",
    min_gt_max: "Минимальный срок хранения не может быть больше максимального.",

    max_required: "Укажите максимальный срок хранения.",
    max_not_number: "Максимальный срок хранения должен быть числом.",
    max_negative: "Максимальный срок хранения не может быть отрицательным.",
    max_gt_365: "Максимальный срок хранения не может превышать 365 дней.",
    max_lt_min: "Максимальный срок хранения не может быть меньше минимального.",
};

const isValidHHmm = (value) => /^([01]\d|2[0-3]):[0-5]\d$/.test(value);

const minutes = (hhmm) => {
    const [h, m] = hhmm.split(":").map(Number);
    return h * 60 + m;
}

const validatePhone = (phone) => {
    const phoneString = (phone || "").trim();

    if (!phoneString) {
        return MESSAGE.phone_required;
    }

    // Must start with +7 and contain digits only afterward
    if (!phoneString.startsWith("+7")) {
        return MESSAGE.phone_format;
    }

    const digits = phoneString.replace(/\D/g, "");
    // +7 plus 10 digits => total digits = 11
    if (digits.length !== 11) {
        return MESSAGE.phone_digits;
    }

    if (!/^\+7\d{10}$/.test(phoneString)) {
        return MESSAGE.phone_format;
    }

    return null;
}

const validateIntervalString = (interval) => {
    const raw = (interval || "").trim();

    if (!raw) {
        return MESSAGE.single_required;
    }

    const parts = raw.split(/–|-/).map((x) => x.trim());

    if (parts.length !== 2) {
        return MESSAGE.single_format;
    }

    const [start, end] = parts;

    if (!isValidHHmm(start) || !isValidHHmm(end)) {
        return MESSAGE.single_format;
    }

    if (minutes(start) >= minutes(end)) {
        return MESSAGE.time_order;
    }

    return null;
}

const validateIntervalDates = (startDate, endDate) => {
    // used for week schedule and set-for-all
    if (!startDate && !endDate) {
        return null; // day off allowed
    }

    if (!startDate || !endDate) {
        return MESSAGE.single_required;
    }

    const start = startDate.toLocaleTimeString("ru").slice(0, 5);
    const end = endDate.toLocaleTimeString("ru").slice(0, 5);

    if (!isValidHHmm(start) || !isValidHHmm(end)) {
        return MESSAGE.week_format;
    }

    if (minutes(start) >= minutes(end)) {
        return MESSAGE.time_order;
    }

    return null;
}

const isNullishValue = (value) => value == null || value === "";
const isInvalidNumber = (value) => !isNullishValue(value)
    && Number.isNaN(Number(value));
const isInvalidRange = (minNumber, maxNumber) => !Number.isNaN(minNumber)
    && !Number.isNaN(maxNumber)
    && minNumber > maxNumber;

const validateStorage = (minValue, maxValue) => {
    const errors = {};
    const minRaw = minValue;
    const maxRaw = maxValue;

    if (isNullishValue(minRaw)) {
        errors.storageMin = MESSAGE.min_required;
    }

    if (isNullishValue(maxRaw)) {
        errors.storageMax = MESSAGE.max_required;
    }

    const minNumber = Number(minRaw);
    const maxNumber = Number(maxRaw);

    if (isInvalidNumber(minRaw)) {
        errors.storageMin = MESSAGE.min_not_number;
    }
    if (isInvalidNumber(maxRaw)) {
        errors.storageMax = MESSAGE.max_not_number;
    }

    if (!Number.isNaN(minNumber)) {
        if (minNumber < 0) {
            errors.storageMin = MESSAGE.min_negative;
        }
        else if (minNumber > 365) {
            errors.storageMin = MESSAGE.min_gt_365;
        }
    }

    if (!Number.isNaN(maxNumber)) {
        if (maxNumber < 0) {
            errors.storageMax = MESSAGE.max_negative;
        }
        else if (maxNumber > 365) {
            errors.storageMax = MESSAGE.max_gt_365;
        }
    }

    if (isInvalidRange(minNumber, maxValue)) {maxNumber
        errors.storageMin = MESSAGE.min_gt_max;
        errors.storageMax = MESSAGE.max_lt_min;
    }

    return errors;
}

export const validateForm = (values, dicts) => {
    // dicts: { cities, streetAbbrOptions, postalServices } for "not from dictionary" checks
    const errors = {};

    // City: required + must be from dict (kato exists)
    if (!values.city || !values.city.kato) {
        errors.city = MESSAGE.city_required;
    }
    else if (dicts?.cities
        && !dicts.cities.some((c) => c?.kato === values.city.kato)) {
        errors.city = MESSAGE.city_not_from_dict;
    }

    // streetType: required + must be from dict
    if (!values.streetType) {
        errors.streetType = MESSAGE.street_type_required;
    }
    else if (dicts?.streetAbbrOptions
        && !dicts.streetAbbrOptions
            .some((s) => s?.id === values.streetType)
    ) {
        errors.streetType = MESSAGE.street_type_not_from_dict;
    }

    // street
    const street = (values.street || "").trim();

    if (!street) {
        errors.street = MESSAGE.street_required;
    }
    else if (street.length < 2) {
        errors.street = MESSAGE.street_too_short;
    }
    else if (street.length > 150) {
        errors.street = MESSAGE.street_too_long;
    }

    // house
    const house = (values.house || "").trim();

    if (!house) {
        errors.house = MESSAGE.house_required;
    }
    else if (house.length > 20) {
        errors.house = MESSAGE.house_too_long;
    }

    // office optional
    const office = (values.office || "").trim();

    if (office && office.length > 20) {
        errors.office = MESSAGE.office_too_long;
    }

    // carrier
    if (!values.cargo) {
        errors.cargo = MESSAGE.carrier_required;
    }
    else if (dicts?.postalServices
        && !dicts.postalServices
            .some((p) => p?.id === values.cargo)
    ) {
        errors.cargo = MESSAGE.carrier_not_from_dict;
    }

    // dispatcher is always required
    const first = (values.name || "").trim();

    if (!first) {
        errors.name = MESSAGE.first_required;
    }
    else if (first.length < 2) {
        errors.name = MESSAGE.first_too_short;
    }
    else if (first.length > 50) {
        errors.name = MESSAGE.first_too_long;
    }

    const last = (values.lastName || "").trim();

    if (!last) {
        errors.lastName = MESSAGE.last_required;
    }
    else if (last.length < 2) {
        errors.lastName = MESSAGE.last_too_short;
    }
    else if (last.length > 50) {
        errors.lastName = MESSAGE.last_too_long;
    }

    const middle = (values.surname || "").trim();

    if (middle) {
        if (middle.length < 2) {
            errors.surname = MESSAGE.middle_too_short;
        }
        else if (middle.length > 50) {
            errors.surname = MESSAGE.middle_too_long;
        }
    }

    const phoneError = validatePhone(values.phone);

    if (phoneError) {
        errors.phone = phoneError;
    }

    // schedule type
    const scheduleType = values.scheduleType;

    if (!scheduleType) {
        errors.scheduleType = MESSAGE.schedule_type_required;
    }
    else if (scheduleType !== "single" && scheduleType !== "week") {
        errors.scheduleType = MESSAGE.schedule_type_invalid;
    }

    // schedule validation
    if (scheduleType === "single") {
        const message = validateIntervalString(values.singleInterval);

        if (message) {
            errors.singleInterval = message;
        }
    }

    if (scheduleType === "week") {
        // weekTime is array 7 of [startDate,endDate]
        const dayErrors = {};

        for (let i = 0; i < 7; i++) {
            const pair = values.weekTime?.[i] || [];
            const message = validateIntervalDates(
                pair[0] || null,
                pair[1] || null
            );

            if (message) {
                dayErrors[i] = message;
            }
        }

        if (Object.keys(dayErrors).length) {
            errors.weekTime = dayErrors;
        }
    }

    // comment
    const comment = (values.comment || "").trim();

    if (comment.length > 500) {
        errors.comment = MESSAGE.comment_too_long;
    }

    // storage
    const storageErrors = validateStorage(values.storageMin, values.storageMax);

    if (storageErrors.storageMin) {
        errors.storageMin = storageErrors.storageMin;
    }

    if (storageErrors.storageMax) {
        errors.storageMax = storageErrors.storageMax;
    }

    return errors;
}

export const hasErrors = (errors) => {
    if (!errors) {
        return false;
    }

    const keys = Object.keys(errors);

    if (!keys.length) {
        return false;
    }

    // weekTime errors nested
    if (keys.length === 1 && keys[0] === "weekTime") {
        return Object.keys(errors.weekTime || {}).length > 0;
    }

    return true;
}
